import { createAction, createSlice } from "@reduxjs/toolkit";

export const pauseWorkflowRequest = createAction("workflowPause/pauseWorkflowRequest");

const initialState = {
  response: null,
  loading: false,
  error: null
};

const workflowPauseSlice = createSlice({
  name: "workflowPause",
  initialState,
  reducers: {
    pauseWorkflowStart(state) {
      state.loading = true;
      state.error = null;
    },
    pauseWorkflowSuccess(state, action) {
      state.loading = false;
      state.response = action.payload || null;
      state.error = null;
    },
    pauseWorkflowFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearWorkflowPauseState(state) {
      state.response = null;
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  pauseWorkflowStart,
  pauseWorkflowSuccess,
  pauseWorkflowFailure,
  clearWorkflowPauseState
} = workflowPauseSlice.actions;

export default workflowPauseSlice.reducer;
